import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";

/** The TT-Norms font does not appear perfectly centered in the avatar circle. Some padding is necessary to shift the letters down. */
export var Initials = styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-top: 0.1em;\n"])));
//# sourceMappingURL=Initials.js.map